export default __webpack_public_path__ + "static/made-okine-sans-light-4a3a31ca389b93ef567b23123e5d5ea7.woff2";